export default "/images/2d57f373bf86fbc28864b6e1e3638b9f.avif";